import { PROTECTED, WAREHOUSE, _LAYOUT } from '@/lib/constants/routes';
import type { SynchWithUrlConfig } from '@/lib/models';
import type { WarehouseFilterTabValue } from './warehouse-filter-tabs';

/**
 * URL di ritorno alle SheetView form dei moduli embedded sotto
 * `/warehouse?subTab=…`. Usato da `_layout.$id.tsx` / `_layout.new.tsx`
 * di products/inventory/price-lists.
 */
export const getWarehouseReturnUrl = (subTab: WarehouseFilterTabValue) =>
  `${PROTECTED}${WAREHOUSE}?subTab=${subTab}`;

/**
 * Config sync URL condiviso dalle 5 tabelle del modulo Magazzino.
 * Tutti i sub-tab vivono sotto `/warehouse?subTab=…`: aggiornamenti di
 * search/sort/pagination restano on-page (nessun route-change tra tab).
 */
export const WAREHOUSE_SYNCH_WITH_URL_CONFIG: SynchWithUrlConfig = {
  replace: true,
  route: `${PROTECTED}${WAREHOUSE}`,
  navigationOptions: {
    from: `${PROTECTED}${_LAYOUT}${WAREHOUSE}/_layout`,
    to: `${PROTECTED}${WAREHOUSE}`,
  },
};
